export const omit = <T extends Record<any, any>, K extends keyof T>(obj: T, ...keys: K[]) => {
  const clonedObject = Object.assign({}, obj)

  keys.forEach(key => {
    delete clonedObject[key]
  })

  return clonedObject
}
